import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for Set
 * Serialized format is a JSON stringified representation of the object
 */
export const setSerializer = CreateSerializer(serializeSet, deserializeSet);
function serializeSet(value) {
    return Array.from(value);
}
function deserializeSet(value) {
    if (typeof value === 'string') {
        value = JSON.parse(value);
    }
    if (Array.isArray(value)) {
        return new Set(value);
    }
    throw new Error('Value was not an array');
}
